/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export type AdminUserConnection = {
  __typename?: 'AdminUserConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<AdminUserType>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AdminUserFilterInput = {
  AND?: InputMaybe<Array<AdminUserFilterInput>>;
  NOT?: InputMaybe<Array<AdminUserFilterInput>>;
  OR?: InputMaybe<Array<AdminUserFilterInput>>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nickname?: InputMaybe<StringFilterInput>;
  organizations?: InputMaybe<HeloOrganizationNestedListFilterInput>;
  updatedDate?: InputMaybe<DateTimeFilterInput>;
};

export type AdminUserOrderByInput = {
  createdDate?: InputMaybe<OrderByEnum>;
  email?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  nickname?: InputMaybe<OrderByEnum>;
  updatedDate?: InputMaybe<OrderByEnum>;
};

export type AdminUserType = {
  __typename?: 'AdminUserType';
  createdDate: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  organizations?: Maybe<Array<HeloOrganization>>;
  roles?: Maybe<Scalars['JSON']['output']>;
  updatedDate: Scalars['DateTime']['output'];
};

export type ApiKeyConnection = {
  __typename?: 'ApiKeyConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<ApiKeyType>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ApiKeyFilterInput = {
  AND?: InputMaybe<Array<ApiKeyFilterInput>>;
  NOT?: InputMaybe<Array<ApiKeyFilterInput>>;
  OR?: InputMaybe<Array<ApiKeyFilterInput>>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  expiresAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  lastUsedAt?: InputMaybe<DateTimeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  updatedDate?: InputMaybe<DateTimeFilterInput>;
};

export type ApiKeyOrderByInput = {
  createdDate?: InputMaybe<OrderByEnum>;
  expiresAt?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  isActive?: InputMaybe<OrderByEnum>;
  lastUsedAt?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  updatedDate?: InputMaybe<OrderByEnum>;
};

export type ApiKeyType = {
  __typename?: 'ApiKeyType';
  createdDate: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  createdDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  /** User who performed the action */
  user?: Maybe<AuditLogUser>;
  userId: Scalars['String']['output'];
};

export type AuditLogConnection = {
  __typename?: 'AuditLogConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<AuditLog>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AuditLogFilterInput = {
  AND?: InputMaybe<Array<AuditLogFilterInput>>;
  NOT?: InputMaybe<Array<AuditLogFilterInput>>;
  OR?: InputMaybe<Array<AuditLogFilterInput>>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  kind?: InputMaybe<StringFilterInput>;
  subjectId?: InputMaybe<StringFilterInput>;
  subjectType?: InputMaybe<StringFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
};

export type AuditLogOrderByInput = {
  createdDate?: InputMaybe<OrderByEnum>;
  description?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  kind?: InputMaybe<OrderByEnum>;
  subjectId?: InputMaybe<OrderByEnum>;
  subjectType?: InputMaybe<OrderByEnum>;
  userId?: InputMaybe<OrderByEnum>;
};

export type AuditLogUser = {
  __typename?: 'AuditLogUser';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BooleanFilterInput = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
};

export enum CookieCategory {
  Analytics = 'ANALYTICS',
  Necessary = 'NECESSARY'
}

export type CreateApiKeyInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
};

export type CreateApiKeyResponseType = {
  __typename?: 'CreateApiKeyResponseType';
  apiKey: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export type CreateCustomerDataApiConfigInput = {
  subgraphConfigs: Array<CreateSubgraphConfigInput>;
};

export type CreateCustomerDataSourceConfigInput = {
  currentVersion: Scalars['String']['input'];
  customerDatabases: Array<CreateCustomerDatabaseConfigInput>;
  id: Scalars['String']['input'];
  isMainIntrospectionDB: Scalars['Boolean']['input'];
  organizationName: Scalars['String']['input'];
};

export type CreateCustomerDatabaseConfigInput = {
  cubeApiUrl?: InputMaybe<Scalars['String']['input']>;
  databaseName: Scalars['String']['input'];
  host: Scalars['String']['input'];
  id: Scalars['String']['input'];
  port: Scalars['Float']['input'];
  version: Scalars['String']['input'];
};

export type CreateSavedViewInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  viewId: Scalars['String']['input'];
  viewState: Scalars['JSON']['input'];
};

export type CreateSubgraphConfigInput = {
  customerDataSources: Array<CreateCustomerDataSourceConfigInput>;
  id: Scalars['String']['input'];
  path: Scalars['String']['input'];
  subgraphName: Scalars['String']['input'];
};

export type CubeApi = {
  __typename?: 'CubeApi';
  apiUrl: Scalars['String']['output'];
};

export type CurrentSmrtArtifactType = {
  __typename?: 'CurrentSmrtArtifactType';
  fields?: Maybe<Scalars['JSON']['output']>;
  introspectionHost?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Scalars['JSON']['output']>;
  resolvedFrom: SmrtArtifactResolvedFrom;
  schema: Scalars['String']['output'];
  schemaId?: Maybe<Scalars['String']['output']>;
  smrtIri: Scalars['String']['output'];
  smrtVersion: Scalars['String']['output'];
  subgraphId: Scalars['String']['output'];
  subgraphName: Scalars['String']['output'];
};

export type CustomerDataApiConfig = {
  __typename?: 'CustomerDataApiConfig';
  /** When this config was created */
  createdDate: Scalars['DateTime']['output'];
  /** All pipeline runs for this config, newest first. */
  deployments: Array<CustomerDataApiDeployment>;
  id: Scalars['ID']['output'];
  /** True iff this config is currently live (matches the latest successful deployment). */
  isActive: Scalars['Boolean']['output'];
  /** User who last updated this config */
  lastUpdatedBy?: Maybe<LastUpdatedByUser>;
  lastUpdatedByUser?: Maybe<Scalars['String']['output']>;
  /** The most recent pipeline run for this config, if any. */
  latestDeployment?: Maybe<CustomerDataApiDeployment>;
  subgraphConfigs: Array<SubgraphConfig>;
  /** When this config was last updated */
  updatedDate: Scalars['DateTime']['output'];
};

export type CustomerDataApiConfigConnection = {
  __typename?: 'CustomerDataApiConfigConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<CustomerDataApiConfig>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerDataApiConfigFilterInput = {
  AND?: InputMaybe<Array<CustomerDataApiConfigFilterInput>>;
  NOT?: InputMaybe<Array<CustomerDataApiConfigFilterInput>>;
  OR?: InputMaybe<Array<CustomerDataApiConfigFilterInput>>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  lastUpdatedByUser?: InputMaybe<StringFilterInput>;
  updatedDate?: InputMaybe<DateTimeFilterInput>;
};

export type CustomerDataApiConfigOrderByInput = {
  createdDate?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  lastUpdatedByUser?: InputMaybe<OrderByEnum>;
  updatedDate?: InputMaybe<OrderByEnum>;
};

export type CustomerDataApiControlResult = {
  __typename?: 'CustomerDataApiControlResult';
  deploymentId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CustomerDataApiCubeHealth = {
  __typename?: 'CustomerDataApiCubeHealth';
  apiUrl?: Maybe<Scalars['String']['output']>;
  configured: Scalars['Boolean']['output'];
  introspection: CustomerDataApiHealthCheck;
  reachability: CustomerDataApiHealthCheck;
};

export type CustomerDataApiCustomerRuntimeStatus = {
  __typename?: 'CustomerDataApiCustomerRuntimeStatus';
  cube: CustomerDataApiCubeHealth;
  currentVersion?: Maybe<Scalars['String']['output']>;
  database: CustomerDataApiHealthCheck;
  databaseName?: Maybe<Scalars['String']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  isDisabled: Scalars['Boolean']['output'];
  organizationName: Scalars['String']['output'];
  port?: Maybe<Scalars['Float']['output']>;
  status: SubgraphStatus;
};

export type CustomerDataApiDeployment = {
  __typename?: 'CustomerDataApiDeployment';
  /** Monotonic attempt number among deployments of this config */
  attempt: Scalars['Int']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /** User who canceled the deployment, if any */
  canceledByUser?: Maybe<DeployedByUser>;
  canceledByUserId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The config used for this deployment */
  config?: Maybe<CustomerDataApiConfig>;
  configId: Scalars['String']['output'];
  /** User who triggered the deployment */
  deployedByUser?: Maybe<DeployedByUser>;
  deployedByUserId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** True iff this deployment is the latest SUCCESS for its config and that config is the currently live one */
  isActive: Scalars['Boolean']['output'];
  /** Last time status/logs were updated (used by the stuck-pipeline watchdog) */
  lastProgressAt: Scalars['DateTime']['output'];
  /** Deployment step logs (append-only) */
  logs?: Maybe<Scalars['String']['output']>;
  /** SMRT versions resolved per subgraph during this deployment run */
  smrtVersions?: Maybe<Array<DeploymentSmrtVersion>>;
  startedAt: Scalars['DateTime']['output'];
  status: DeploymentStatus;
};

export type CustomerDataApiDeploymentConnection = {
  __typename?: 'CustomerDataApiDeploymentConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<CustomerDataApiDeployment>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CustomerDataApiDeploymentFilterInput = {
  AND?: InputMaybe<Array<CustomerDataApiDeploymentFilterInput>>;
  NOT?: InputMaybe<Array<CustomerDataApiDeploymentFilterInput>>;
  OR?: InputMaybe<Array<CustomerDataApiDeploymentFilterInput>>;
  completedAt?: InputMaybe<DateTimeFilterInput>;
  configId?: InputMaybe<StringFilterInput>;
  deployedByUserId?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  startedAt?: InputMaybe<DateTimeFilterInput>;
  status?: InputMaybe<DeploymentStatusFilterInput>;
};

export type CustomerDataApiDeploymentOrderByInput = {
  completedAt?: InputMaybe<OrderByEnum>;
  configId?: InputMaybe<OrderByEnum>;
  deployedByUserId?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  startedAt?: InputMaybe<OrderByEnum>;
  status?: InputMaybe<OrderByEnum>;
};

export type CustomerDataApiHealthCheck = {
  __typename?: 'CustomerDataApiHealthCheck';
  accessible: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  responseTimeMs?: Maybe<Scalars['Float']['output']>;
};

export type CustomerDataApiPipelineRuntimeStatus = {
  __typename?: 'CustomerDataApiPipelineRuntimeStatus';
  deploymentId?: Maybe<Scalars['String']['output']>;
  running: Scalars['Boolean']['output'];
};

export type CustomerDataApiRuntimeControlResult = {
  __typename?: 'CustomerDataApiRuntimeControlResult';
  deploymentId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CustomerDataApiRuntimeStatus = {
  __typename?: 'CustomerDataApiRuntimeStatus';
  error?: Maybe<Scalars['String']['output']>;
  managerAccessible: Scalars['Boolean']['output'];
  pipeline: CustomerDataApiPipelineRuntimeStatus;
  status?: Maybe<Scalars['String']['output']>;
  subgraphs: Array<CustomerDataApiSubgraphRuntimeStatus>;
  subgraphsServiceRunning: Scalars['Boolean']['output'];
};

export type CustomerDataApiServiceStatus = {
  __typename?: 'CustomerDataApiServiceStatus';
  accessible: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomerDataApiStatus = {
  __typename?: 'CustomerDataApiStatus';
  cache: CustomerDataApiServiceStatus;
  checkedAt: Scalars['DateTime']['output'];
  cubeIntrospection: CustomerDataApiServiceStatus;
  cubeService: CustomerDataApiServiceStatus;
  inProgressDeployments: Array<CustomerDataApiStatusDeploymentRef>;
  liveConfig?: Maybe<CustomerDataApiStatusConfigRef>;
  liveDeployment?: Maybe<CustomerDataApiStatusDeploymentRef>;
  liveSmrtArtifacts: Array<CustomerDataApiStatusArtifactRef>;
  manager: CustomerDataApiServiceStatus;
  managerRuntime?: Maybe<Scalars['JSON']['output']>;
  subgraphsService: CustomerDataApiServiceStatus;
};

export type CustomerDataApiStatusArtifactRef = {
  __typename?: 'CustomerDataApiStatusArtifactRef';
  id: Scalars['String']['output'];
  introspectionHost?: Maybe<Scalars['String']['output']>;
  resolvedFrom?: Maybe<Scalars['String']['output']>;
  schemaId?: Maybe<Scalars['String']['output']>;
  smrtIri: Scalars['String']['output'];
  smrtVersion: Scalars['String']['output'];
  subgraphId: Scalars['String']['output'];
  subgraphName: Scalars['String']['output'];
};

export type CustomerDataApiStatusConfigRef = {
  __typename?: 'CustomerDataApiStatusConfigRef';
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export type CustomerDataApiStatusDeploymentRef = {
  __typename?: 'CustomerDataApiStatusDeploymentRef';
  attempt: Scalars['Float']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  configId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type CustomerDataApiSubgraphRuntimeStatus = {
  __typename?: 'CustomerDataApiSubgraphRuntimeStatus';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customers: Array<CustomerDataApiCustomerRuntimeStatus>;
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  recentLogs: Array<Scalars['String']['output']>;
  status: SubgraphStatus;
  subgraphName: Scalars['String']['output'];
};

export type CustomerDataSourceConfig = {
  __typename?: 'CustomerDataSourceConfig';
  currentVersion: Scalars['String']['output'];
  customerDatabases: Array<CustomerDatabaseConfig>;
  id: Scalars['ID']['output'];
  isMainIntrospectionDB: Scalars['Boolean']['output'];
  organizationName: Scalars['String']['output'];
};

export type CustomerDatabaseConfig = {
  __typename?: 'CustomerDatabaseConfig';
  cubeApiUrl?: Maybe<Scalars['String']['output']>;
  databaseName: Scalars['String']['output'];
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  port: Scalars['Float']['output'];
  version: Scalars['String']['output'];
};

export type CustomerDatasource = {
  __typename?: 'CustomerDatasource';
  cube?: Maybe<CubeApi>;
  currentVersion: Scalars['String']['output'];
  database?: Maybe<PostgresDatabase>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isMainIntrospectionDB: Scalars['Boolean']['output'];
  logs: Array<Scalars['String']['output']>;
  organizationName: Scalars['String']['output'];
  status: SubgraphStatus;
};

export type DateTimeFilterInput = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DeployedByUser = {
  __typename?: 'DeployedByUser';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DeploymentSmrtVersion = {
  __typename?: 'DeploymentSmrtVersion';
  smrtIri: Scalars['String']['output'];
  smrtVersion: Scalars['String']['output'];
  subgraphName: Scalars['String']['output'];
};

/** Status of a Customer Data API deployment */
export enum DeploymentStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type DeploymentStatusFilterInput = {
  equals?: InputMaybe<DeploymentStatus>;
  in?: InputMaybe<Array<DeploymentStatus>>;
  not?: InputMaybe<DeploymentStatusFilterInput>;
  notIn?: InputMaybe<Array<DeploymentStatus>>;
};

export type ElectrumPythonDatasourceVersion = {
  __typename?: 'ElectrumPythonDatasourceVersion';
  /** Organization name for the datasource (e.g. owensminor, rei, starbucks, costco). */
  organizationName: Scalars['String']['output'];
  /** Active database version for this organization (e.g. green or blue). */
  version: Scalars['String']['output'];
};

export type ElectrumPythonDatasourceVersionInput = {
  /** Organization name for the datasource (e.g. owensminor, rei, starbucks, costco). */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Database version to activate for this organization (e.g. green or blue). */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ElectrumPythonSubgraphConfig = {
  __typename?: 'ElectrumPythonSubgraphConfig';
  /** All customer datasources configured on the electrumpython subgraph. */
  datasources: Array<ElectrumPythonDatasourceVersion>;
};

export enum GatewaySubgraphComposeStatus {
  Excluded = 'EXCLUDED',
  Included = 'INCLUDED',
  Unreachable = 'UNREACHABLE'
}

export type GatewaySubgraphStatus = {
  __typename?: 'GatewaySubgraphStatus';
  error?: Maybe<Scalars['String']['output']>;
  lastComposedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  status: GatewaySubgraphComposeStatus;
  url: Scalars['String']['output'];
};

export type GatewaySupergraphReloadExcluded = {
  __typename?: 'GatewaySupergraphReloadExcluded';
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type GatewaySupergraphReloadResult = {
  __typename?: 'GatewaySupergraphReloadResult';
  degraded: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  excluded: Array<GatewaySupergraphReloadExcluded>;
  included: Array<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type GatewaySupergraphStatus = {
  __typename?: 'GatewaySupergraphStatus';
  degraded: Scalars['Boolean']['output'];
  lastReloadAt?: Maybe<Scalars['DateTime']['output']>;
  subgraphs: Array<GatewaySubgraphStatus>;
};

export type HeloOrganization = {
  __typename?: 'HeloOrganization';
  auth0Id: Scalars['String']['output'];
  createdDate: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export type HeloOrganizationConnection = {
  __typename?: 'HeloOrganizationConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<HeloOrganization>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type HeloOrganizationFilterInput = {
  AND?: InputMaybe<Array<HeloOrganizationFilterInput>>;
  NOT?: InputMaybe<Array<HeloOrganizationFilterInput>>;
  OR?: InputMaybe<Array<HeloOrganizationFilterInput>>;
  auth0Id?: InputMaybe<StringFilterInput>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  displayName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  updatedDate?: InputMaybe<DateTimeFilterInput>;
};

export type HeloOrganizationNestedListFilterInput = {
  every?: InputMaybe<HeloOrganizationFilterInput>;
  none?: InputMaybe<HeloOrganizationFilterInput>;
  some?: InputMaybe<HeloOrganizationFilterInput>;
};

export type HeloOrganizationOrderByInput = {
  auth0Id?: InputMaybe<OrderByEnum>;
  createdDate?: InputMaybe<OrderByEnum>;
  displayName?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  updatedDate?: InputMaybe<OrderByEnum>;
};

export type IntFilterInput = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LastUpdatedByUser = {
  __typename?: 'LastUpdatedByUser';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Cancel a pipeline run. Only affects non-terminal deployments (PENDING or IN_PROGRESS). Db-subgraphs aborts in-flight work where possible. */
  cancelCustomerDataApiDeployment: CustomerDataApiDeployment;
  clearAllCaches: RedisOperationResult;
  clearCustomerDataApiCache: CustomerDataApiControlResult;
  clearCustomerDataApiRuntimeCache: CustomerDataApiRuntimeControlResult;
  createApiKey: CreateApiKeyResponseType;
  createCustomerDataApiConfig: CustomerDataApiConfig;
  createSavedView: SavedView;
  deleteSavedView: Scalars['Boolean']['output'];
  markAllNotificationsAsRead: Scalars['String']['output'];
  markNotificationAsRead: Scalars['String']['output'];
  notifyCustomerDataApiConfigChanged: CustomerDataApiControlResult;
  queryExport: QueryExportType;
  reloadCustomerDataApi: CustomerDataApiControlResult;
  reloadCustomerDataApiRuntime: CustomerDataApiRuntimeControlResult;
  /** Recompose the gateway supergraph after subgraph schemas change. */
  reloadSupergraph: GatewaySupergraphReloadResult;
  /** Best-effort abort of an in-flight pipeline run on db-subgraphs. Distinct from the API cancelCustomerDataApiDeployment mutation that updates deployment rows. */
  requestCustomerDataApiDeploymentCancellation: CustomerDataApiControlResult;
  /** Clone the deployment config as a new version and notify db-subgraphs to deploy it. */
  rerunCustomerDataApiDeployment?: Maybe<CustomerDataApiDeployment>;
  revokeApiKey: ApiKeyType;
  /** Saves a new config version (history is append-only). Behaves identically to createCustomerDataApiConfig; kept for backwards compatibility. */
  updateCustomerDataApiConfig: CustomerDataApiConfig;
  /** Updates electrumpython subgraph datasource versions and/or SMRT version, then triggers deployment. */
  updateElectrumPythonSubgraphConfig: ElectrumPythonSubgraphConfig;
  updateSavedView: SavedView;
  updateUserSettings: UserSettings;
};


export type MutationCancelCustomerDataApiDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type MutationCreateApiKeyArgs = {
  input: CreateApiKeyInput;
};


export type MutationCreateCustomerDataApiConfigArgs = {
  input: CreateCustomerDataApiConfigInput;
};


export type MutationCreateSavedViewArgs = {
  input: CreateSavedViewInput;
};


export type MutationDeleteSavedViewArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['String']['input'];
};


export type MutationQueryExportArgs = {
  input: QueryExportInput;
};


export type MutationReloadSupergraphArgs = {
  deploymentId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestCustomerDataApiDeploymentCancellationArgs = {
  deploymentId: Scalars['String']['input'];
};


export type MutationRerunCustomerDataApiDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type MutationRevokeApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateCustomerDataApiConfigArgs = {
  input: UpdateCustomerDataApiConfigInput;
};


export type MutationUpdateElectrumPythonSubgraphConfigArgs = {
  input: UpdateElectrumPythonSubgraphConfigInput;
};


export type MutationUpdateSavedViewArgs = {
  input: UpdateSavedViewInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};

export type Notification = {
  __typename?: 'Notification';
  category: NotificationCategory;
  createdDate: Scalars['DateTime']['output'];
  estimatedDurationMs?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  queryExport?: Maybe<QueryExport>;
  queryStartTime?: Maybe<Scalars['DateTime']['output']>;
  updatedDate: Scalars['DateTime']['output'];
};

export enum NotificationCategory {
  Error = 'ERROR',
  Info = 'INFO',
  Pending = 'PENDING'
}

export type NotificationCategoryFilterInput = {
  equals?: InputMaybe<NotificationCategory>;
  in?: InputMaybe<Array<NotificationCategory>>;
  not?: InputMaybe<NotificationCategoryFilterInput>;
  notIn?: InputMaybe<Array<NotificationCategory>>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Notification>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type NotificationFilterInput = {
  AND?: InputMaybe<Array<NotificationFilterInput>>;
  NOT?: InputMaybe<Array<NotificationFilterInput>>;
  OR?: InputMaybe<Array<NotificationFilterInput>>;
  category?: InputMaybe<NotificationCategoryFilterInput>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  isRead?: InputMaybe<BooleanFilterInput>;
  message?: InputMaybe<StringFilterInput>;
  organizationId?: InputMaybe<StringFilterInput>;
  queryDefinitionId?: InputMaybe<StringFilterInput>;
  queryStartTime?: InputMaybe<DateTimeFilterInput>;
  retrievedRowCount?: InputMaybe<IntFilterInput>;
  totalRowCount?: InputMaybe<IntFilterInput>;
  updatedDate?: InputMaybe<DateTimeFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
};

export type NotificationOrderByInput = {
  category?: InputMaybe<OrderByEnum>;
  createdDate?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  isRead?: InputMaybe<OrderByEnum>;
  message?: InputMaybe<OrderByEnum>;
  updatedDate?: InputMaybe<OrderByEnum>;
};

export enum OrderByEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PostgresDatabase = {
  __typename?: 'PostgresDatabase';
  databaseName: Scalars['String']['output'];
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logs: Array<Scalars['String']['output']>;
  port: Scalars['Float']['output'];
  status: SubgraphStatus;
  version: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  AdminUser_list: AdminUserConnection;
  ApiKey_list: ApiKeyConnection;
  AuditLog_list: AuditLogConnection;
  /** List all configs (history), ordered by updatedDate desc */
  CustomerDataApiConfig_list: CustomerDataApiConfigConnection;
  /** List deployments, most recent first */
  CustomerDataApiDeployment_list: CustomerDataApiDeploymentConnection;
  Notification_list: NotificationConnection;
  OrganizationSavedView_list: SavedViewConnection;
  Organization_list: HeloOrganizationConnection;
  SavedView_list: SavedViewConnection;
  /** Lists SMRT artifact versions available in blob storage (read-only viewer). */
  SmrtArtifact_list: SmrtArtifactConnection;
  adminUserById?: Maybe<AdminUserType>;
  auditLog?: Maybe<AuditLog>;
  currentSmrtArtifacts: Array<CurrentSmrtArtifactType>;
  currentUser: UserType;
  /** Returns the currently live config (config of the most recent SUCCESS deployment). */
  customerDataApiConfig: CustomerDataApiConfig;
  /** Get a config by id */
  customerDataApiConfigById?: Maybe<CustomerDataApiConfig>;
  /** Get a deployment by id */
  customerDataApiDeploymentById?: Maybe<CustomerDataApiDeployment>;
  customerDataApiRuntimeStatus: CustomerDataApiRuntimeStatus;
  customerDataApiStatus: CustomerDataApiStatus;
  dataTypeConfigs: Scalars['JSON']['output'];
  /** Base URL of the db-subgraphs service (scheme, host, port only). Clients append configured subgraph paths for GraphQL endpoints. */
  dbSubgraphsUrl: Scalars['String']['output'];
  downloadNotificationFile: Scalars['Boolean']['output'];
  /** Returns datasource versions and SMRT version for the electrumpython subgraph only. */
  electrumPythonSubgraphConfig: ElectrumPythonSubgraphConfig;
  /** Gateway supergraph composition status: which subgraphs are included, excluded, or unreachable. */
  gatewaySupergraphStatus: GatewaySupergraphStatus;
  helloFromCustomerDataApiManager: Scalars['String']['output'];
  /** Returns the internal auth token for the current user */
  internalToken: Scalars['String']['output'];
  mapperConfigs: Scalars['JSON']['output'];
  organizationById?: Maybe<HeloOrganization>;
  queryDefinitions: Scalars['JSON']['output'];
  redisPing: RedisOperationResult;
  savedView?: Maybe<SavedView>;
  schemaHash: Scalars['String']['output'];
  sdl: Scalars['String']['output'];
  sidebarConfigs: Scalars['JSON']['output'];
  /** Downloads and returns the SMRT artifact for a version from blob storage. */
  smrtArtifactByVersion?: Maybe<SmrtArtifact>;
  stateConfigs: Scalars['JSON']['output'];
  subgraphs: Array<Subgraph>;
  userSettings?: Maybe<UserSettings>;
  viewConfigs: Scalars['JSON']['output'];
};


export type QueryAdminUser_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AdminUserOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryApiKey_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ApiKeyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuditLog_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AuditLogFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerDataApiConfig_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerDataApiConfigFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerDataApiConfigOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerDataApiDeployment_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerDataApiDeploymentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerDataApiDeploymentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotification_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<NotificationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationSavedView_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SavedViewFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavedViewOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganization_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HeloOrganizationFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HeloOrganizationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySavedView_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SavedViewFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SavedViewOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySmrtArtifact_ListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUserByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryAuditLogArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerDataApiConfigByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerDataApiDeploymentByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryDownloadNotificationFileArgs = {
  fileId: Scalars['String']['input'];
};


export type QueryHelloFromCustomerDataApiManagerArgs = {
  roundtrip?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryOrganizationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QuerySavedViewArgs = {
  id: Scalars['String']['input'];
};


export type QuerySmrtArtifactByVersionArgs = {
  smrtVersion: Scalars['String']['input'];
};

export type QueryExport = {
  __typename?: 'QueryExport';
  createdDate: Scalars['DateTime']['output'];
  estimatedDurationMs?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  queryDefinitionId: Scalars['String']['output'];
  queryStartTime?: Maybe<Scalars['DateTime']['output']>;
  retrievedRowCount?: Maybe<Scalars['Float']['output']>;
  status: QueryExportStatus;
  totalRowCount?: Maybe<Scalars['Float']['output']>;
  updatedDate: Scalars['DateTime']['output'];
};

export type QueryExportInput = {
  columnConfigs?: InputMaybe<Scalars['JSON']['input']>;
  columns?: InputMaybe<Scalars['JSON']['input']>;
  connectionLocator?: InputMaybe<Scalars['JSON']['input']>;
  fileName: Scalars['String']['input'];
  queryDefinitionId: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export enum QueryExportStatus {
  Error = 'ERROR',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type QueryExportType = {
  __typename?: 'QueryExportType';
  createdDate: Scalars['DateTime']['output'];
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedDate: Scalars['DateTime']['output'];
};

export type RedisOperationResult = {
  __typename?: 'RedisOperationResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SavedView = {
  __typename?: 'SavedView';
  createdDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  tableConfig?: Maybe<Scalars['JSON']['output']>;
  updatedDate: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  viewId: Scalars['String']['output'];
  viewState: Scalars['JSON']['output'];
};

export type SavedViewConnection = {
  __typename?: 'SavedViewConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<SavedView>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SavedViewFilterInput = {
  AND?: InputMaybe<Array<SavedViewFilterInput>>;
  NOT?: InputMaybe<Array<SavedViewFilterInput>>;
  OR?: InputMaybe<Array<SavedViewFilterInput>>;
  createdDate?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  organizationId?: InputMaybe<StringFilterInput>;
  updatedDate?: InputMaybe<DateTimeFilterInput>;
  userId?: InputMaybe<StringFilterInput>;
  viewId?: InputMaybe<StringFilterInput>;
};

export type SavedViewOrderByInput = {
  createdDate?: InputMaybe<OrderByEnum>;
  description?: InputMaybe<OrderByEnum>;
  id?: InputMaybe<OrderByEnum>;
  name?: InputMaybe<OrderByEnum>;
  organizationId?: InputMaybe<OrderByEnum>;
  updatedDate?: InputMaybe<OrderByEnum>;
  userId?: InputMaybe<OrderByEnum>;
  viewId?: InputMaybe<OrderByEnum>;
};

export type SmrtArtifact = {
  __typename?: 'SmrtArtifact';
  fields?: Maybe<Scalars['JSON']['output']>;
  /** SMRT version (used as the artifact identifier) */
  id: Scalars['ID']['output'];
  models?: Maybe<Scalars['JSON']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  schemaId?: Maybe<Scalars['String']['output']>;
  smrtIri?: Maybe<Scalars['String']['output']>;
  smrtVersion: Scalars['String']['output'];
};

export type SmrtArtifactConnection = {
  __typename?: 'SmrtArtifactConnection';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  items: Array<SmrtArtifact>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum SmrtArtifactResolvedFrom {
  Db = 'DB',
  Pin = 'PIN'
}

export type StringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  /** Case sensitivity mode for string filtering */
  mode?: InputMaybe<StringFilterMode>;
  not?: InputMaybe<StringFilterInput>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum StringFilterMode {
  Insensitive = 'insensitive',
  Sensitive = 'sensitive'
}

export type Subgraph = {
  __typename?: 'Subgraph';
  artifactDirectory: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customers: Array<CustomerDatasource>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  logs: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  status: SubgraphStatus;
  subgraphName: Scalars['String']['output'];
  tables: Array<Scalars['String']['output']>;
};

export type SubgraphConfig = {
  __typename?: 'SubgraphConfig';
  customerDataSources: Array<CustomerDataSourceConfig>;
  fallbackSmrtIri?: Maybe<Scalars['String']['output']>;
  fallbackSmrtVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  path: Scalars['String']['output'];
  subgraphName: Scalars['String']['output'];
};

/** Status of subgraph components */
export enum SubgraphStatus {
  Degraded = 'DEGRADED',
  Disabled = 'DISABLED',
  Error = 'ERROR',
  Initial = 'INITIAL',
  Ready = 'READY'
}

export type UpdateCustomerDataApiConfigInput = {
  id: Scalars['ID']['input'];
  subgraphConfigs: Array<CreateSubgraphConfigInput>;
};

export type UpdateElectrumPythonSubgraphConfigInput = {
  /** Optional datasource version updates. Each entry with organizationName + version updates that datasource. */
  datasources?: InputMaybe<Array<ElectrumPythonDatasourceVersionInput>>;
};

export type UpdateSavedViewInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tableConfig?: InputMaybe<Scalars['JSON']['input']>;
  viewId?: InputMaybe<Scalars['String']['input']>;
  viewState?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserSettingsInput = {
  cookieCategories?: InputMaybe<Array<CookieCategory>>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  cookieCategories?: Maybe<Array<CookieCategory>>;
  cookieConsentDate?: Maybe<Scalars['DateTime']['output']>;
  createdDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedDate: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type UserType = {
  __typename?: 'UserType';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  organizations: Array<HeloOrganization>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};

export enum Join__Graph {
  App = 'APP',
  DbSubgraphsManager = 'DB_SUBGRAPHS_MANAGER'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type NotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderByInput> | NotificationOrderByInput>;
}>;


export type NotificationsQuery = { __typename?: 'Query', Notification_list: { __typename?: 'NotificationConnection', items: Array<{ __typename?: 'Notification', id: string, createdDate: any, updatedDate: any, message: string, isRead: boolean, category: NotificationCategory, queryExport?: { __typename?: 'QueryExport', id: string, createdDate: any, updatedDate: any, fileId?: string | null, fileName?: string | null, status: QueryExportStatus, message?: string | null, queryDefinitionId: string, retrievedRowCount?: number | null, totalRowCount?: number | null, estimatedDurationMs?: number | null, queryStartTime?: any | null } | null }> } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: string };

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['String']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: string };

export type QueryExportMutationVariables = Exact<{
  input: QueryExportInput;
}>;


export type QueryExportMutation = { __typename?: 'Mutation', queryExport: { __typename?: 'QueryExportType', id: string, createdDate: any, updatedDate: any, fileId: string, fileName: string, status: string, message?: string | null } };

export type CreateApiKeyMutationVariables = Exact<{
  input: CreateApiKeyInput;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'CreateApiKeyResponseType', id: string, name: string, createdDate: any, updatedDate: any, lastUsedAt?: any | null, expiresAt?: any | null, isActive: boolean, apiKey: string } };

export type RevokeApiKeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RevokeApiKeyMutation = { __typename?: 'Mutation', revokeApiKey: { __typename?: 'ApiKeyType', id: string } };

export type ApiKeysQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ApiKeyOrderByInput> | ApiKeyOrderByInput>;
}>;


export type ApiKeysQuery = { __typename?: 'Query', ApiKey_list: { __typename?: 'ApiKeyConnection', items: Array<{ __typename?: 'ApiKeyType', id: string, name: string, createdDate: any, updatedDate: any, lastUsedAt?: any | null, expiresAt?: any | null, isActive: boolean }> } };

export type UserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSettingsQuery = { __typename?: 'Query', userSettings?: { __typename?: 'UserSettings', cookieCategories?: Array<CookieCategory> | null } | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { __typename?: 'Mutation', updateUserSettings: { __typename?: 'UserSettings', cookieCategories?: Array<CookieCategory> | null } };

export type CmsConfigsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsConfigsQueryQuery = { __typename?: 'Query', dataTypeConfigs: any, stateConfigs: any, viewConfigs: any, sidebarConfigs: any, queryDefinitions: any, mapperConfigs: any, schemaHash: string };

export type SchemaHashQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SchemaHashQueryQuery = { __typename?: 'Query', schemaHash: string };

export type CreateCustomerDataApiConfigMutationVariables = Exact<{
  input: CreateCustomerDataApiConfigInput;
}>;


export type CreateCustomerDataApiConfigMutation = { __typename?: 'Mutation', createCustomerDataApiConfig: { __typename?: 'CustomerDataApiConfig', id: string, isActive: boolean, subgraphConfigs: Array<{ __typename?: 'SubgraphConfig', id: string, subgraphName: string, path: string, customerDataSources: Array<{ __typename?: 'CustomerDataSourceConfig', id: string, organizationName: string, currentVersion: string, isMainIntrospectionDB: boolean, customerDatabases: Array<{ __typename?: 'CustomerDatabaseConfig', id: string, version: string, host: string, port: number, databaseName: string, cubeApiUrl?: string | null }> }> }> } };

export type CustomerDataApiConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerDataApiConfigQuery = { __typename?: 'Query', customerDataApiConfig: { __typename?: 'CustomerDataApiConfig', id: string, isActive: boolean, lastUpdatedByUser?: string | null, subgraphConfigs: Array<{ __typename?: 'SubgraphConfig', id: string, subgraphName: string, path: string, customerDataSources: Array<{ __typename?: 'CustomerDataSourceConfig', id: string, organizationName: string, currentVersion: string, isMainIntrospectionDB: boolean, customerDatabases: Array<{ __typename?: 'CustomerDatabaseConfig', id: string, version: string, host: string, port: number, databaseName: string, cubeApiUrl?: string | null }> }> }> } };

export type CustomerDataApiConfigsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerDataApiConfigsQuery = { __typename?: 'Query', CustomerDataApiConfig_list: { __typename?: 'CustomerDataApiConfigConnection', items: Array<{ __typename?: 'CustomerDataApiConfig', id: string, isActive: boolean, lastUpdatedByUser?: string | null, updatedDate: any, createdDate: any, subgraphConfigs: Array<{ __typename?: 'SubgraphConfig', id: string, subgraphName: string, path: string, customerDataSources: Array<{ __typename?: 'CustomerDataSourceConfig', id: string, organizationName: string, currentVersion: string, isMainIntrospectionDB: boolean, customerDatabases: Array<{ __typename?: 'CustomerDatabaseConfig', id: string, version: string, host: string, port: number, databaseName: string, cubeApiUrl?: string | null }> }> }> }> } };

export type CustomerDataApiConfigByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CustomerDataApiConfigByIdQuery = { __typename?: 'Query', customerDataApiConfigById?: { __typename?: 'CustomerDataApiConfig', id: string, isActive: boolean, lastUpdatedByUser?: string | null, subgraphConfigs: Array<{ __typename?: 'SubgraphConfig', id: string, subgraphName: string, path: string, customerDataSources: Array<{ __typename?: 'CustomerDataSourceConfig', id: string, organizationName: string, currentVersion: string, isMainIntrospectionDB: boolean, customerDatabases: Array<{ __typename?: 'CustomerDatabaseConfig', id: string, version: string, host: string, port: number, databaseName: string, cubeApiUrl?: string | null }> }> }> } | null };

export type UpdateCustomerDataApiConfigMutationVariables = Exact<{
  input: UpdateCustomerDataApiConfigInput;
}>;


export type UpdateCustomerDataApiConfigMutation = { __typename?: 'Mutation', updateCustomerDataApiConfig: { __typename?: 'CustomerDataApiConfig', id: string, isActive: boolean, subgraphConfigs: Array<{ __typename?: 'SubgraphConfig', id: string, subgraphName: string, path: string, customerDataSources: Array<{ __typename?: 'CustomerDataSourceConfig', id: string, organizationName: string, currentVersion: string, isMainIntrospectionDB: boolean, customerDatabases: Array<{ __typename?: 'CustomerDatabaseConfig', id: string, version: string, host: string, port: number, databaseName: string, cubeApiUrl?: string | null }> }> }> } };

export type SmrtArtifactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SmrtArtifactsQuery = { __typename?: 'Query', SmrtArtifact_list: { __typename?: 'SmrtArtifactConnection', items: Array<{ __typename?: 'SmrtArtifact', id: string, smrtVersion: string }> } };

export type SmrtArtifactByVersionQueryVariables = Exact<{
  smrtVersion: Scalars['String']['input'];
}>;


export type SmrtArtifactByVersionQuery = { __typename?: 'Query', smrtArtifactByVersion?: { __typename?: 'SmrtArtifact', id: string, smrtIri?: string | null, smrtVersion: string, schemaId?: string | null, models?: any | null, fields?: any | null, schema?: string | null } | null };

export type SavedViewsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SavedViewsQuery = { __typename?: 'Query', SavedView_list: { __typename?: 'SavedViewConnection', items: Array<{ __typename?: 'SavedView', id: string, name: string, description: string, viewId: string, viewState: any, tableConfig?: any | null, createdDate: any, updatedDate: any, userId: string, organizationId: string }> } };

export type SavedViewQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SavedViewQuery = { __typename?: 'Query', savedView?: { __typename?: 'SavedView', id: string, name: string, description: string, viewId: string, viewState: any, tableConfig?: any | null, createdDate: any, updatedDate: any, userId: string, organizationId: string } | null };

export type CreateSavedViewMutationVariables = Exact<{
  input: CreateSavedViewInput;
}>;


export type CreateSavedViewMutation = { __typename?: 'Mutation', createSavedView: { __typename?: 'SavedView', id: string, name: string, description: string, viewId: string, viewState: any, tableConfig?: any | null, createdDate: any, updatedDate: any, userId: string, organizationId: string } };

export type UpdateSavedViewMutationVariables = Exact<{
  input: UpdateSavedViewInput;
}>;


export type UpdateSavedViewMutation = { __typename?: 'Mutation', updateSavedView: { __typename?: 'SavedView', id: string, name: string, description: string, viewId: string, viewState: any, tableConfig?: any | null, createdDate: any, updatedDate: any, userId: string, organizationId: string } };

export type DeleteSavedViewMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteSavedViewMutation = { __typename?: 'Mutation', deleteSavedView: boolean };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'UserType', id: string, email: string, name?: string | null, nickname?: string | null, roles?: Array<string> | null, organizations: Array<{ __typename?: 'HeloOrganization', id: string, name: string, displayName: string }> } };

export type InternalDirectQueryDevtoolsContextQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalDirectQueryDevtoolsContextQuery = { __typename?: 'Query', internalToken: string, dbSubgraphsUrl: string };


export const NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Notifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Notification_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"isRead"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"queryExport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"queryDefinitionId"}},{"kind":"Field","name":{"kind":"Name","value":"retrievedRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalRowCount"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDurationMs"}},{"kind":"Field","name":{"kind":"Name","value":"queryStartTime"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const MarkAllNotificationsAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAllNotificationsAsRead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAllNotificationsAsRead"}}]}}]} as unknown as DocumentNode<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const MarkNotificationAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"notificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}]}]}}]} as unknown as DocumentNode<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const QueryExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QueryExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryExportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<QueryExportMutation, QueryExportMutationVariables>;
export const CreateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateApiKeyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createApiKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}}]}}]} as unknown as DocumentNode<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const RevokeApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeApiKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RevokeApiKeyMutation, RevokeApiKeyMutationVariables>;
export const ApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApiKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApiKeyOrderByInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ApiKey_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]}}]} as unknown as DocumentNode<ApiKeysQuery, ApiKeysQueryVariables>;
export const UserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cookieCategories"}}]}}]}}]} as unknown as DocumentNode<UserSettingsQuery, UserSettingsQueryVariables>;
export const UpdateUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cookieCategories"}}]}}]}}]} as unknown as DocumentNode<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const CmsConfigsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmsConfigsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataTypeConfigs"}},{"kind":"Field","name":{"kind":"Name","value":"stateConfigs"}},{"kind":"Field","name":{"kind":"Name","value":"viewConfigs"}},{"kind":"Field","name":{"kind":"Name","value":"sidebarConfigs"}},{"kind":"Field","name":{"kind":"Name","value":"queryDefinitions"}},{"kind":"Field","name":{"kind":"Name","value":"mapperConfigs"}},{"kind":"Field","name":{"kind":"Name","value":"schemaHash"}}]}}]} as unknown as DocumentNode<CmsConfigsQueryQuery, CmsConfigsQueryQueryVariables>;
export const SchemaHashQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SchemaHashQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemaHash"}}]}}]} as unknown as DocumentNode<SchemaHashQueryQuery, SchemaHashQueryQueryVariables>;
export const CreateCustomerDataApiConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerDataApiConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerDataApiConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerDataApiConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphName"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"customerDataSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"isMainIntrospectionDB"}},{"kind":"Field","name":{"kind":"Name","value":"customerDatabases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"databaseName"}},{"kind":"Field","name":{"kind":"Name","value":"cubeApiUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateCustomerDataApiConfigMutation, CreateCustomerDataApiConfigMutationVariables>;
export const CustomerDataApiConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerDataApiConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerDataApiConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphName"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"customerDataSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"isMainIntrospectionDB"}},{"kind":"Field","name":{"kind":"Name","value":"customerDatabases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"databaseName"}},{"kind":"Field","name":{"kind":"Name","value":"cubeApiUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerDataApiConfigQuery, CustomerDataApiConfigQueryVariables>;
export const CustomerDataApiConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerDataApiConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"CustomerDataApiConfig_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updatedDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphName"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"customerDataSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"isMainIntrospectionDB"}},{"kind":"Field","name":{"kind":"Name","value":"customerDatabases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"databaseName"}},{"kind":"Field","name":{"kind":"Name","value":"cubeApiUrl"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerDataApiConfigsQuery, CustomerDataApiConfigsQueryVariables>;
export const CustomerDataApiConfigByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerDataApiConfigById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerDataApiConfigById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedByUser"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphName"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"customerDataSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"isMainIntrospectionDB"}},{"kind":"Field","name":{"kind":"Name","value":"customerDatabases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"databaseName"}},{"kind":"Field","name":{"kind":"Name","value":"cubeApiUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerDataApiConfigByIdQuery, CustomerDataApiConfigByIdQueryVariables>;
export const UpdateCustomerDataApiConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomerDataApiConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCustomerDataApiConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomerDataApiConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subgraphName"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"customerDataSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"isMainIntrospectionDB"}},{"kind":"Field","name":{"kind":"Name","value":"customerDatabases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"databaseName"}},{"kind":"Field","name":{"kind":"Name","value":"cubeApiUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerDataApiConfigMutation, UpdateCustomerDataApiConfigMutationVariables>;
export const SmrtArtifactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SmrtArtifacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SmrtArtifact_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"smrtVersion"}}]}}]}}]}}]} as unknown as DocumentNode<SmrtArtifactsQuery, SmrtArtifactsQueryVariables>;
export const SmrtArtifactByVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SmrtArtifactByVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smrtVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smrtArtifactByVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"smrtVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smrtVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"smrtIri"}},{"kind":"Field","name":{"kind":"Name","value":"smrtVersion"}},{"kind":"Field","name":{"kind":"Name","value":"schemaId"}},{"kind":"Field","name":{"kind":"Name","value":"models"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}},{"kind":"Field","name":{"kind":"Name","value":"schema"}}]}}]}}]} as unknown as DocumentNode<SmrtArtifactByVersionQuery, SmrtArtifactByVersionQueryVariables>;
export const SavedViewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavedViews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"SavedView_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"viewId"}},{"kind":"Field","name":{"kind":"Name","value":"viewState"}},{"kind":"Field","name":{"kind":"Name","value":"tableConfig"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]}}]} as unknown as DocumentNode<SavedViewsQuery, SavedViewsQueryVariables>;
export const SavedViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SavedView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"viewId"}},{"kind":"Field","name":{"kind":"Name","value":"viewState"}},{"kind":"Field","name":{"kind":"Name","value":"tableConfig"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]} as unknown as DocumentNode<SavedViewQuery, SavedViewQueryVariables>;
export const CreateSavedViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSavedView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSavedViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSavedView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"viewId"}},{"kind":"Field","name":{"kind":"Name","value":"viewState"}},{"kind":"Field","name":{"kind":"Name","value":"tableConfig"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]} as unknown as DocumentNode<CreateSavedViewMutation, CreateSavedViewMutationVariables>;
export const UpdateSavedViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSavedView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSavedViewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSavedView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"viewId"}},{"kind":"Field","name":{"kind":"Name","value":"viewState"}},{"kind":"Field","name":{"kind":"Name","value":"tableConfig"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedDate"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}}]}}]}}]} as unknown as DocumentNode<UpdateSavedViewMutation, UpdateSavedViewMutationVariables>;
export const DeleteSavedViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteSavedViewMutation, DeleteSavedViewMutationVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const InternalDirectQueryDevtoolsContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalDirectQueryDevtoolsContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalToken"}},{"kind":"Field","name":{"kind":"Name","value":"dbSubgraphsUrl"}}]}}]} as unknown as DocumentNode<InternalDirectQueryDevtoolsContextQuery, InternalDirectQueryDevtoolsContextQueryVariables>;